/**
 * Global settings
 */
const now = Date.now(),
    projects = {
        "auto": {
            "label": "Voiture",
            "oldness": true
        },
        "moto": {
            "label": "Moto",
            "oldness": true
        },
        "campingcar": {
            "label": "Camping-car",
            "oldness": true
        },
        "travaux": {
            "label": "Travaux",
            "oldness": false
        },
        "equloisir": {
            "label": "Équipements / Loisirs",
            "oldness": false
        },
        "vehiculecollec": {
            "label": "Véhicules de collection",
            "oldness": false
        },
        "bateau": {
            "label": "Bateau",
            "oldness": false
        },
        "tresorerie": { /* same as equloisir */
            "label": "Besoin de trésorerie",
            "oldness": false
        }
    },
    projectPrefix = "cc",
    /* tresorerie project is not in backoffice,
    so we apply data grid of other projects: equloisir */
    projectTypesAlias = {
        "cctresorerie": "ccequloisir"
    },
    projectOldness = {
        "0": {
            "auto": "neuve ou occasion de moins d'1 an",
            "moto": "neuve ou occasion de moins d'1 an",
            "campingcar": "neuf ou occasion de moins d'1 an"
        },
        "10": "occasion de plus d'1 an à 5 ans",
        "20": "occasion de plus de 5 ans à 7 ans",
        "21": "occasion de plus de 7 ans"
    },
    /* we apply equloisir grid to projects
    with an oldness higher than 7 years */
    projectOldnessAlias = {
        "ccauto21": "ccequloisir",
        "ccmoto21": "ccequloisir",
        "cccampingcar21": "ccequloisir"
    },
    /* Amount limits for prospects (ENV="DESKTOP") */
    public_amount_max = 75000,
    public_amount_min = 5000,
    /* -0.75% for CP3 or A+/A- */
    isWithdrawal = false,
    /* Default duration */
    default_duration = 12,
    /* Insurance rate */
    insurance_rate = 0.07,
    /* Setup fees */
    setup_fees = 0,
    /* Collab settings */
    collab = false,
    /* if collab, we apply cccollab grid to all projects (cf. Rate_Collab in backoffice) */
    collab_grid = "cccollab",
    /* CTA */
    prospectURL = DEV ?
        /** Contact form doesn't work properly: it doesn't find the nearest agency (2023-07-31) **/
        // "https://www.axa.fr/contacter-agent/contacter-conseiller.html" :
        // "https://www.axa.fr/contacter-agent/contacter-conseiller.html",
        "https://agence.axa.fr/?pretPerso" :
        "https://agence.axa.fr/?pretPerso",
    customerURL = DEV ?
        "https://preview-salt-recprjmkt.axa.fr/compte-bancaire/pret-personnel/devis-pret-perso.html" :
        "https://www.axa.fr/compte-bancaire/pret-personnel/devis-pret-perso.html",
    customerMobileURL = DEV ?
        "https://mon-ab.hml.bad.arkea.com/messagerie/ecriremessage" :
        "https://banque.axa.fr/messagerie/nouveau-message",
    collabURL = DEV ?
        "https://preview-pp.axa.fr/compte-bancaire/annexes-axabanque/offre-collaborateur-AXA/collab-demande-rendez-vous.html" :
        "https://axa.fr/compte-bancaire/annexes-axabanque/offre-collaborateur-AXA/collab-demande-rendez-vous.html";
    /* URL parameters presets */
    let parameters = {};

/**
 * Legal mentions
 * Replaces the footer legal paragraphs (all but the title) with promo-specific ones.
 */
function renderLegalMentions(paragraphs) {
   if (!Array.isArray(paragraphs) || paragraphs.length === 0) {
      return;
   }
   const body = document.querySelector(".axb-legal-mentions__body");
   if (!body) {
      return;
   }
   const title = body.querySelector("p");
   if (!title) {
      return;
   }
   let current = title.nextElementSibling;
   while (current) {
      const next = current.nextElementSibling;
      if (current.tagName === "P") {
         current.remove();
      }
      current = next;
   }
   paragraphs.forEach(html => {
      const p = document.createElement("p");
      p.innerHTML = '<span class="text-legal text--xs">' + html + "</span>";
      body.appendChild(p);
   });
}

/**
 * Credit data
 */
var valid_discount_code = false,
   discount_code = null,
   discount_code_label = null,
   current_global_discount = null,
   current_actioncom_discount = null,
   additional_fields = null,

   credit = null,
   current_global_discounts = null,
   current_actioncom_discounts = null,
   credit_rates = [],
   credit_amount_min = public_amount_min,
   credit_amount_max = public_amount_max,
   credit_durations = [],

   project = null,
   project_type = null,
   project_name = null,
   project_oldness = "",
   credit_amount = null,
   credit_duration = null,
   credit_monthly_cost = 0,
   credit_interest = 0,
   insurance_monthly_cost = 0,
   insurance_credit_monthly_cost = 0,
   insurance_interest = 0,
   deb_rate = 0,
   taeg = 0,
   taea = 0;

/**
 * setCreditData
 * Set up credit data
 */
function setCreditData(project_type) {
   credit = credits[project_type] || null;
   // console.log("credit", credit);

   const isActionComDiscount = (
      current_actioncom_discount
      && current_actioncom_discount.isValid
      && current_actioncom_discount.isAppliable
   );

   if (credit) {
      initCreditData({
         "amount_max": isActionComDiscount ? parseInt(current_actioncom_discount.maximum_amount) : parseInt(credit.maximum_amount),
         "amount_min": isActionComDiscount ? parseInt(current_actioncom_discount.minimum_amount) : parseInt(credit.minimum_amount),
         "duration_max": isActionComDiscount ? parseInt(current_actioncom_discount.durations[current_actioncom_discount.durations.length - 1]) : credit.maximum_duration,
         "duration_min": isActionComDiscount ? parseInt(current_actioncom_discount.durations[0]) : credit.minimum_duration
      });
   }

   setCreditDuration();
}

/**
 * initCreditData
 * Initialize base credit data
 */
function initCreditData(args) {
   // console.log("credit_rates", credit_rates);

   credit_amount_min = args.amount_min;
   if (ENV === "APP-MOBILE" || collab || parameters['axapassion']) {
      credit_amount_min = args.amount_min;
   } else {
      credit_amount_min = args.amount_min >= public_amount_min ? args.amount_min : public_amount_min;
   }

   credit_amount_max = args.amount_max;
   if (ENV === "APP-MOBILE" || collab || parameters['axapassion']) {
      credit_amount_max = args.amount_max;
   } else {
      credit_amount_max =
         project === "travaux" ? args.amount_max :
            (args.amount_max <= public_amount_max ? args.amount_max : public_amount_max);
   }

   credit_amount = isCreditAmountValid(credit_amount) ? credit_amount : null;

   credit_durations = [];
   for (let nb_months = args.duration_min; nb_months <= args.duration_max; nb_months += 12) {
      credit_durations.push(nb_months);
   }
}

/**
 * resetCreditData
 * Reset base credit data
 */
function resetCreditData() {
   let projects_list = null;
   if (current_actioncom_discounts && current_actioncom_discount) {
      projects_list = Object.keys(current_actioncom_discounts).filter(elt => {
         return Object.keys(projects).indexOf((elt.replace(projectPrefix, ""))) !== -1;
      });
   }
   /* Project */
   project = (projects_list && projects_list.length <= 1) ? 
      current_actioncom_discount.project_type_identifier.replace(projectPrefix, "").replace(/[0-9]/g, '') : null;
   project_type = current_actioncom_discount ? current_actioncom_discount.project_type_identifier : null;
   project_name = project ? projects[project] : null;
   project_oldness = "";
   credit = credits[project_type] ? credits[project_type] : null;
   /* Credit amount */
   credit_amount = null;
   /* Credit durations */
   credit_durations = current_actioncom_discount ? current_actioncom_discount.durations : [];
   credit_duration = default_duration;

   computeData();
   renderUI();
}

/**
 * resetActionComDiscountData
 * Reset actioncomdiscount data
 */
function resetActionComDiscountData() {
   discount_code = null;
   current_actioncom_discount = null;

   computeData();
   renderUI();
}

/**
 * Credit preset
 */

/* API */
var apiURL = DEV_API ? "https://backoffice-simulateurs-dev.axabanque-dvd.com/api/" : "https://backoffice-simulateurs.axabanque-dvd.com/api/",
    credits_url = apiURL + "project-types?show_hidden=1",
    settings_url = apiURL + "simulator-settings",
    rate_url = apiURL + "personal-loan-simulator/get-rate",
    discount_url = apiURL + "personal-loan-simulator/promo-code/",
    discounts_special_url = "/dam/axa/desktop/banque-credits/banque-simulateur-credit-conso/actioncomdiscounts_special.json";


/* Data get from server */
var credits = null,
    rates = null,
    actioncomdiscounts = null,
    actioncomdiscounts_special = null;

/**
 * getCredits
 */
function getCredits() {
  let requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  fetch(credits_url, requestOptions)
    .then(response => response.text())
    .then((result) => {
      let data = JSON.parse(result).data;
      credits = data.reduce((acc, it) => ({ ...acc, [it.identifier]: it }), {});
      presetFormByUrl();
    })
    .catch(error => console.log('error', error));
}

/**
 * getRates
 * (taeg)
 */
function getRates(projectType, loanAmount = null, durations, codePromo = null) {
  let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  let urlencoded = new URLSearchParams();
      urlencoded.append("projectType", collab ? collab_grid : projectType);
      urlencoded.append("loanAmount", loanAmount ? loanAmount : credit_amount_min);
      urlencoded.append("type", "aga");
      durations.forEach(element => {
        urlencoded.append("durations[]", element);
      });
      urlencoded.append("promotionalCode", codePromo ? codePromo : "-");
      urlencoded.append("offer", "classic");
      urlencoded.append("preQualification", collab ? "-" : "CP3");
      urlencoded.append("indiceBanque", collab ? "-" : "A");
      urlencoded.append("isWithdrawal", isWithdrawal); // isWithdrawal: apply -0.75% for CP3 or A+/A-

  let requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow'
  };

  fetch(rate_url, requestOptions)
    .then(response => response.text())
    .then((result) => {
      rates = JSON.parse(result).durations;
      computeData();
      renderUI();
    })
    .catch(error => console.log('error', error));
}

/**
 * getDiscount
 */
function getDiscount(codePromo) {
  let requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  fetch(discount_url + codePromo, requestOptions)
    .then(response => {
      return (response.status === 200) ? response.text() : null;
    })
    .then(result => {
      actioncomdiscounts = result ? JSON.parse(result) : {};
      setCurrentActionComDiscount(codePromo, actioncomdiscounts, true);
    })
    .catch(error => {
      console.log('error', error);
    });
}

/**
 * getDiscountsSpecial
 */
function getDiscountsSpecial() {
  let requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  fetch(discounts_special_url, requestOptions)
    .then(response => response.text())
    .then((result) => {
      actioncomdiscounts_special = JSON.parse(result);
      if (credits && actioncomdiscounts) {
        presetFormByUrl();
      }
    })
    .catch(error => console.log('error', error));
}

/**
 * presetFormByUrl
 */
function presetFormByUrl() {
  /* Parameters (get) */
  let UrlParser = new GetURLParams(window.location.search);
  parameters = UrlParser.urlParams;

  if (parameters["promo"]) {
    let codePromo = parameters["promo"].toUpperCase();
    getDiscount(codePromo);
  }

  if (parameters["projet"]) {
    let selectedProject = parameters["projet"].replace(/[012]/g, ""),
        selectedProjectSuffix = parameters["projet"].match(/\d+/g);

    $project.setAttribute("disabled", "disabled");
    $projectField.classList.add("hidden");
    setProject(selectedProject);
    setProjectOldness(selectedProjectSuffix ? selectedProjectSuffix[0] : "");

    if (parameters["montant"]) {
      setCreditAmount(parameters["montant"]);
    }

    if (parameters["duree"]) {
      setCreditDuration(parameters["duree"]);
    }

    getRates(credit.identifier, credit_amount, credit_durations, discount_code);
  }

  if (
    (parameters["client"] && parameters["client"] === 'oui') ||
    (parameters["collab"] && parameters["collab"] === 'oui') ||
    (parameters["utm_source"] && parameters["utm_source"] === 'gmb')
  ) {
    // Hide CTA stepper to have only one button
    if ($desktopCTAStepper) {
      $desktopCTAStepper.classList.add('hidden');
    }
    // Show single CTA
    if ($singleCTA) {
      $singleCTA.classList.remove('hidden');
    }
  }

  if (parameters["collab"] && parameters["collab"] === 'oui') {
    collab = true;
  }

  if (parameters["AGA"] || parameters["A2P"]) {
    // Hide intro
    $simuIntro.style.display = "none";

    // Hide credit type field and credit infos block
    $creditTypeField.style.display = "none";
    $creditInfos.style.display = "none";

    // Hide additionals fields
    document.querySelector('.c-additional-fields').style.display = "none";

    // Hide warning block
    document.querySelector('.c-section.c-warning').style.display = "none";

    // Hide CTA
    document.querySelector(".c-section.c-cta").style.display = "none";
  }

  if (parameters["axapassion"]) { // for AXA PASSION bundle (test on june 2023 / to improve)

    if (actioncomdiscounts_special) {
      let specialDiscountCodes = Object.keys(actioncomdiscounts_special);
      let specialCode = "AXAPASSION" + (project ? "_" + project.toUpperCase() : "");

      if (specialDiscountCodes.indexOf(specialCode) !== -1) {
        let specialDiscount = actioncomdiscounts_special[specialCode];

        let projectDurations = [credit.minimum_duration];
        for (let i = credit.minimum_duration; i < credit.maximum_duration; i+= 12) {
          projectDurations.push(credit.minimum_duration + i);
        }

        current_actioncom_discount = {
          code: specialCode,
          project_type_identifier: (project ? projectPrefix + project : ""),
          durations: projectDurations,
          maximum_amount: '120000',
          minimum_amount: '5000',
          end_date: '2050-12-12 00:00:00',
          start_date: '2000-12-12 00:00:00',
          isValid: true,
          isAppliable: (ENV === "APP-MOBILE" && specialDiscount.mobile) ||
            (ENV === "DESKTOP" && specialDiscount.desktop),
          cssTheme: specialDiscount.theme,
          additionalFields: specialDiscount.fields,
          additionalSections: specialDiscount.sections,
          discountLabel: specialDiscount.label,
          discountLabelShort: specialDiscount.labelShort,
          discountIntro: specialDiscount.introduction,
          discountCatchphrase: specialDiscount.catchphrase,
          discountCtaCatchphrase: specialDiscount.cta_catchphrase,
          discountMentions: specialDiscount.mentions,
          discountMentionsShort: specialDiscount.mentionsShort,
          avantagesPP: specialDiscount.avantagesPP,
          hideProposedOffer: specialDiscount.hideProposedOffer === true,
          blocPromoOnTop: specialDiscount.blocPromoOnTop === true,
          hideCurrentOfferInMentions: specialDiscount.hideCurrentOfferInMentions === true
        };

        if (project) {
          current_actioncom_discounts = {};
          current_actioncom_discounts[projectPrefix + project] = current_actioncom_discount;
          for (let value in projectOldness) {
            if (value === '0') {
              continue;
            }
            let item = current_actioncom_discount;
            item.project_type_identifier = projectPrefix + project + getProjectOldness(value);
            current_actioncom_discounts[projectPrefix + project + getProjectOldness(value)] = item;
          }
        }

        if (current_actioncom_discount.isAppliable) {
          renderLegalMentions(specialDiscount.legalMentions);
        }
        setAdditionalFields(specialDiscount.fields);
        computeData();
        renderUI();
      }
    }

    // Hide credit type field and credit infos block
    $creditTypeField.style.display = "none";
    $creditInfos.style.display = "none";

    // Hide desktop CTA
    if ($desktopCTAStepper) {
      $desktopCTAStepper.classList.add("hidden");
    }
    // Hide mobile CTA
    if ($mobileCTAStepper) {
      $mobileCTAStepper.classList.add('hidden');
    }
    // Show AXA Passion CTA
    if ($axapassionCTA_rdv) {
      $axapassionCTA_rdv.classList.remove("hidden");
      document.querySelector('#cta-mobile-stepper ~ p span').classList.add("hidden");
    }
    if (
      $axapassionCTA_devis
      && parameters["utm_content"]
      && (
        [
          'bundle_campingcar_inapp',
          'mamoto24',
        ].indexOf(parameters["utm_content"]) !== -1
      )
    ) {
      $axapassionCTA_rdv.classList.add("hidden");
      $axapassionCTA_devis.classList.remove("hidden");
      document.querySelector('#cta-mobile-stepper ~ p span').classList.remove("hidden");
      document.querySelector('#cta-mobile-stepper ~ p span').innerText = "Votre Agent AXA va prendre contact avec vous.";
    }
  }

  console.log("ENV", ENV);
}

/**
 * renderProject
 * Display project fields (project + project oldness)
 */
function renderProject(projectsList = {}) {
   // console.log("renderProject", projectsList);

   if (!project) {
     $project.value = "";
   }

   // Handle case when projects list is defined by a discount (with code promo)
   if (Object.keys(projectsList).length > 0) {
      $project.innerHTML = "<option value=''>Sélectionnez...</option>";

      for (let value in projectsList) {
         $project.innerHTML +=
            "<option value='" + value + "'" + (value == (projectPrefix + project) ? "selected" : "") + ">"
               + projectsList[value].label
            + "</option>";
      }

      // Handle case when there is only one project in select dropdown
      if (Object.keys(projectsList).length <= 1 || parameters["projet"]) {
         $projectField.classList.add("hidden");
      }
   } else {
      let $optionElt = document.querySelector('option[value=' + projectPrefix + project + ']');
      if ($optionElt) {
         $optionElt.selected = true;
      }
   }

   if (project) {
      if (isProjectValid(project)) {
         $project.classList.add("valid");
         $project.classList.remove("error");
      } else {
         $project.classList.add("error");
         $project.classList.remove("valid");
      }
   } else {
      $project.classList.remove("valid");
      $project.classList.remove("error");
   }

   // Handle project oldness dropdown select
   if (project && projects[project].oldness) {
      $projectOldness.innerHTML = "<option value=''>Sélectionnez...</option>";
      for (let value in projectOldness) {
         if (current_actioncom_discount && current_actioncom_discount.isValid &&
             current_actioncom_discount.isEligible && current_actioncom_discount.isAppliable) {
            let project_type_alias = (projectTypesAlias[projectPrefix + project] || project).replace(projectPrefix, ""),
                discount_project_type = value == "0" ? projectPrefix + project_type_alias : projectPrefix + project_type_alias + getProjectOldness(value);
            let discount_project_types = Object.keys(current_actioncom_discounts);

            if (discount_project_types.indexOf(discount_project_type) === -1) {
               continue;
            }
         }
         $projectOldness.innerHTML +=
            "<option value='" + value + "'" + (value == project_oldness ? "selected" : "") + ">"
               + (value == "0" ? projectOldness[value][project] : projectOldness[value])
            + "</option>";
      }
      $projectOldnessField.classList.remove("hidden");
   } else {
      $projectOldnessField.classList.add("hidden");
   }

   if (project_oldness) {
      if (isProjectOldnessValid(project_oldness)) {
         $projectOldness.classList.add("valid");
         $projectOldness.classList.remove("error");
      } else {
         $projectOldness.classList.add("error");
         $projectOldness.classList.remove("valid");
      }
   } else {
      $projectOldness.classList.remove("valid");
      $projectOldness.classList.remove("error");
   }
}

/**
 * setProject
 * Initialize form with selected project in select field
 * Called each time selected project change
 */
function setProject(value, projectList = {}) {
   // Set up project infos according to selected value
   project = value.replace(projectPrefix, "");
   // console.log("project", project);

   project_type = projectTypesAlias[value] || value;
   project_type += projects[project].oldness ? getProjectOldness() : "";
   project_type = projectOldnessAlias[project_type] || project_type;
   // console.log("project_type", project_type);

   project_name = projects[project].label;
   // console.log("project_name", project_name);

   setCreditData(project_type);

   computeData(true);
   renderUI(projectList);
}

/**
 * setProjectOldness
 */
function setProjectOldness(value) {
   project_oldness = value;
   // console.log("project_oldness", project_oldness);
   setProject(projectPrefix + project);
}

/**
 * getProjectOldness
 */
function getProjectOldness(value = null) {
   let oldness = value && value.length >= 0 ? value : project_oldness;

   if (!oldness) {
      return "";
   }

   // "21" is equivalent to "occasion de plus de 7 ans" (cf. settings.js)
   if (oldness == "21") {
      return oldness;
   }

   let val = (parseInt(oldness) / 10).toFixed(0);
   return val != 0 ? val : "";
}

/**
 * isProjectValid
 */
function isProjectValid(value) {
  if (!value) {
    return false;
  }

  return true;
}

/**
 * isProjectOldnessValid
 */
function isProjectOldnessValid(value) {
   if (!value && projects[project].oldness) {
     return false;
   }

   return true;
}

/**
 * renderCreditAmount
 * Display credit amount field
 */
function renderCreditAmount() {
   if (!project) {
    $creditAmount.classList.remove('valid');
    $creditAmount.classList.remove('error');
   }

   $creditAmountField.querySelector(".c-label__placeholder").innerHTML = "Entre "
    + stringifyPrice(credit_amount_min).replace(" ", "&nbsp;") + " à "
    + stringifyPrice(credit_amount_max).replace(" ", "&nbsp;") + "&nbsp;€";
   $creditAmount.setAttribute(
     "placeholder",
     "Entre " + stringifyPrice(credit_amount_min) + " et " + stringifyPrice(credit_amount_max) + " €"
   );
   $creditAmountField.querySelector(".c-field__error").innerHTML = "Veuillez saisir un montant compris entre "
      + stringifyPrice(credit_amount_min).replace(" ", "&nbsp;") + " et "
      + stringifyPrice(credit_amount_max).replace(" ", "&nbsp;") + "&nbsp;€.";

   $creditAmount.value = stringifyPrice(credit_amount);

   if ($creditTypeField) {
    document.querySelector("label[for=credit-type-pp] .c-radio-button__highlighted-label").innerHTML = "De "
      + stringifyPrice(credit_amount_min).replace(" ", "&nbsp;") + " à "
      + stringifyPrice(credit_amount_max).replace(" ", "&nbsp;") + "&nbsp;€";
   }

  if (credit_amount) {
    if (isCreditAmountValid(credit_amount)) {
      $creditAmount.classList.add("valid");
      $creditAmount.classList.remove("error");
    } else {
      $creditAmount.classList.add("error");
      $creditAmount.classList.remove("valid");
    }
  } else {
    $creditAmount.classList.remove("valid");
    $creditAmount.classList.remove("error");
  }
}

/**
 * setCreditAmount
 */
function setCreditAmount(value) {
   credit_amount = numerizePrice(value);
   // console.log("credit_amount", credit_amount);
   computeData(true);
   renderUI();
}

/**
 * isCreditAmountValid
 */
function isCreditAmountValid(value) {
  if (!value) {
    return false;
  }

  return parseInt(value) >= credit_amount_min && parseInt(value) <= credit_amount_max;
}

/**
 * getAmountStep
 */
function getAmountStep(value, amountSteps) {
  for (let i = amountSteps.length-1; i >= 0; --i) {
    const amountStep = parseInt(amountSteps[i]);
    if (value >= amountStep) {
      return amountStep;
    }
  }
  return amountSteps[0];
}
/**
 * renderCreditDuration
 * Display credit duration field
 */
function renderCreditDuration() {
  if (
     isProjectValid(project) && isProjectOldnessValid(project_oldness)
     && isCreditAmountValid(credit_amount)
  ) {
    $creditDurationField.classList.remove("hidden");
    toggleCreditTypeAndInfos(true);
  } else {
    $creditDurationField.classList.add("hidden");
    toggleCreditTypeAndInfos(false);
  }

  $creditDuration.innerHTML = "";

  if (rates) {
    Object.keys(rates).forEach(nb_months => {
      let cost_per_month = vpm(getTaeg(parseInt(nb_months)), parseInt(nb_months), credit_amount); // + insurance_monthly_cost;
      let nb_years = nb_months / 12;
  
      $creditDuration.innerHTML +=
        "<option value='" + nb_months + "'" + (nb_months == credit_duration ? "selected" : "") + ">"
          + stringifyPrice(cost_per_month.toFixed(2)) + " € / mois sur "
          + nb_years + " " + ((nb_years > 1) ? "ans" : "an")
        + "</option>";
      // $creditDuration.innerHTML +=
      //   "<div class='c-radio-button c-radio-button--block'>"
      //   +  "<input id='credit-duration-" + nb_months + "' name='credit-duration' type='radio' value='" + nb_months + "'" + (nb_months == credit_duration ? "checked" : "") + " onchange='setCreditDuration(this.value);' >"
      //   +   "<label for='credit-duration-" + nb_months + "'>"
      //   +      "<span class='c-radio-button__label'>" + (nb_years ? (nb_years > 1 ? nb_years + " ans" : nb_years + " an") : (nb_months + " mois")) + "</span>"
      //   +      "<span class='c-radio-button__highlighted-label'>" + stringifyPrice(cost_per_month.toFixed(2)) + " € / mois</span>"
      //   +   "</label>"
      //   + "</div>"
    });
  }

  let creditDurationClassName = ($creditDuration.className).replace("valid", "").replace("error", "").trim();
  $creditDuration.setAttribute("class", creditDurationClassName);
  $creditDuration.setAttribute("class", creditDurationClassName + " " + (isCreditDurationValid(credit_duration) ? "valid" : "error"));
}

/**
 * toggleCreditTypeAndInfos
 * Show or hide the credit type field and the credit infos block
 */
function toggleCreditTypeAndInfos(isVisible) {
  if (isVisible) {
    if ($creditTypeField && !current_actioncom_discount?.hideProposedOffer) {
      $creditTypeField.classList.remove('hidden');
    }
    // Promo block on top is managed by renderDiscount()
    if (current_actioncom_discount?.avantagesPP && !current_actioncom_discount?.blocPromoOnTop) {
      $creditInfos.classList.remove('hidden');
    }
  } else {
    if ($creditTypeField) {
      $creditTypeField.classList.add('hidden');
    }
    if (!current_actioncom_discount?.blocPromoOnTop) {
      $creditInfos.classList.add('hidden');
    }
  }
}

/**
 * setCreditDuration
 */
function setCreditDuration(value = null) {
  if (value) {
    credit_duration = parseInt(value);
  } else {
    credit_duration = credit_durations && credit_durations.length > 0 ? credit_durations[0] : default_duration;
  }
  // console.log("credit_duration", credit_duration);
  computeData();
  renderUI();
}

/**
 * isCreditDurationValid
 */
function isCreditDurationValid(value) {
  if (!value) {
    return false;
  }

  return credit_durations.indexOf(value) !== -1;
}

/**
 * renderDiscountIntro
 * Non-empty string: replace the default intro. Empty / whitespace-only string: hide it.
 * null / undefined / non-string: keep the default intro from the HTML.
 */
function renderDiscountIntro(intro) {
   if (typeof intro !== "string") {
      return;
   }
   if (intro.trim() === "") {
      $simuIntro.classList.add("hidden");
   } else {
      $simuIntro.innerHTML = intro;
   }
}

/**
 * renderDiscount
 * Display discount infos (header, additional fields, legal mentions, etc.)
 */
function renderDiscount() {
   let className = ($discountDescription.className).replace("hidden", "").trim();

   if (discount_code || parameters['axapassion']) { /* actioncomdiscount */
      if (current_actioncom_discount) {
         // Layout & fields
         if (current_actioncom_discount.isAppliable && current_actioncom_discount.isValid) {
            $simuPP.setAttribute("class", current_actioncom_discount.cssTheme);
            renderAdditionalFields();
         }
         // Header + intro
         if (current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) {
            $discountLabel.innerHTML = current_actioncom_discount.discountLabel ?
               current_actioncom_discount.discountLabel : "";
            $discountCatchphrase.innerHTML = current_actioncom_discount.discountCatchphrase ?
               current_actioncom_discount.discountCatchphrase : "";
            renderDiscountIntro(current_actioncom_discount.discountIntro);
            $durationTooltip.classList.add("hidden");
         }
         // Radio button credit type
         if ($creditTypeField) {
            document.querySelector("label[for=credit-type-pp] .c-radio-button__sublabel").classList.remove("hidden");
            document.querySelector("label[for=credit-type-pp] .c-radio-button__sublabel").innerHTML = current_actioncom_discount.discountLabelShort;
         }
         // Description
         const hideCurrentOffer = current_actioncom_discount.isAppliable
            && current_actioncom_discount.isValid
            && current_actioncom_discount.hideCurrentOfferInMentions === true;
         if (!hideCurrentOffer) {
            $discountDescription.setAttribute("class", className);
         }
         if (!current_actioncom_discount.isAppliable) {
            $discountDescription.innerHTML =
               "<p>Ce code promo n'est pas applicable dans cet environnement.</p>";
         } else if (current_actioncom_discount.isValid) {
            if (!hideCurrentOffer) {
               $discountDescription.innerHTML =
                  "<p><span class='semibold'>En cours&nbsp;:</span> " + current_actioncom_discount.discountLabelShort + "</p>";
            }
         } else {
            $discountDescription.innerHTML =
               "<p>Ce code promotionnel n'est plus valide.</p>";
         }
         // CTA catchphrase
         if (current_actioncom_discount.isAppliable && current_actioncom_discount.isValid && current_actioncom_discount.discountCtaCatchphrase) {
            $ctaCatchphrase.innerHTML = current_actioncom_discount.discountCtaCatchphrase;
            $ctaCatchphrase.classList.remove("hidden");
         }
         // Avantages PP
         if (current_actioncom_discount.isAppliable && current_actioncom_discount.isValid && current_actioncom_discount.avantagesPP) {
            $creditInfos.querySelector(".c-tip").innerHTML = current_actioncom_discount.avantagesPP.title + current_actioncom_discount.avantagesPP.body;
            // Promo block on top of the page (right after the h1), visible immediately
            if (current_actioncom_discount.blocPromoOnTop) {
               let $introTitle = document.querySelector(".c-section.c-intro .c-wrapper > h1");
               if ($introTitle) {
                  if ($introTitle.nextElementSibling !== $creditInfos) {
                     $introTitle.after($creditInfos);
                  }
                  $creditInfos.classList.add("promo-on-top");
                  $creditInfos.classList.remove("hidden");
               }
            }
         }
         // Mentions
         if (current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) {
            $discountMentions.innerHTML = current_actioncom_discount.discountMentions;
            $discountMentions.classList.remove("hidden");
         }

         /* hide global discount mentions */
         if (current_actioncom_discount.isValid && current_actioncom_discount.isAppliable && current_actioncom_discount.discountMentions) {
            $discountMentionsGlobal.classList.add("hidden");
         }
      } else {
         $discountDescription.innerHTML = "<p><strong>Il n'existe pas de taux promotionnel lié à ce code promo.</strong></p>";
      }
   }

   if (!parameters["AGA"] && !parameters["A2P"]) {
      // GREEN21
      if (discount_code === "GREEN21") {
         // Show CTA section
         document.querySelector('.c-section.c-cta').classList.remove('hidden');

         // Hide desktop CTA
         if ($desktopCTAStepper) {
            $desktopCTAStepper.classList.add('hidden');
         }
         // Show single CTA
         if ($singleCTA) {
            $singleCTA.classList.remove('hidden');
         }

         if (
            parameters["utm_content"] &&
            (
               parameters["utm_content"] === 'simulateur_messagerie_GREEN_direct_cta' ||
               parameters["utm_content"] === 'simulateur_messagerie_travaux_GREEN_intermedie_cta' ||
               parameters["utm_content"] === 'simulateur_messagerie_auto_GREEN_intermedie_cta' ||
               parameters["utm_content"] === 'GREEN_inapp_direct' || parameters["utm_content"] === 'GREEN_inapp_inter'
            )
         ) {
            // Hide single CTA
            if ($singleCTA) {
               $singleCTA.classList.add('hidden');
            }
            // Show mobile customer CTA
            if ($mobileCTAStepper) {
               $mobileCTAStepper.classList.remove('hidden');
               document.querySelector('#cta-mobile-stepper ~ p span').classList.remove("hidden");
            }
         }
      }

      // IC2025
      if (discount_code === "IC2025" || discount_code === "ICCR2025") {
         // Show CTA section
         document.querySelector('.c-section.c-cta').classList.remove('hidden');

         // Hide desktop CTA
         if ($desktopCTAStepper) {
            $desktopCTAStepper.classList.add('hidden');
         }
         // Show single CTA
         if ($singleCTA) {
            $singleCTA.classList.remove('hidden');
         }

         if (
            parameters["utm_content"] &&
            (
               [
                  'ic_2025_directs_lancement',
                  'ic_2025_directs_relance',
                  'ic_2025_directs_qlqs_jours',
                  'ic_2025_directs_inter_lancement',
                  'ic_2025_directs_inter_relance',
                  'ic_2025_directs_inter_qlqs_jours',
               ].indexOf(parameters["utm_content"]) !== -1
            )
         ) {
            // Hide single CTA
            if ($singleCTA) {
               $singleCTA.classList.add('hidden');
            }
            // Show mobile customer CTA
            if ($mobileCTAStepper) {
               $mobileCTAStepper.classList.remove('hidden');
               document.querySelector('#cta-mobile-stepper ~ p span').classList.remove("hidden");
            }
         }
      }

      // PDC2026
      if (discount_code === "PDC2026") {
         // Show CTA section
         document.querySelector('.c-section.c-cta').classList.remove('hidden');

         // Hide desktop CTA
         if ($desktopCTAStepper) {
            $desktopCTAStepper.classList.add('hidden');
         }
         // Show single CTA (→ devis générique) for clt_assures and clt_interm
         if ($singleCTA) {
            $singleCTA.classList.remove('hidden');
         }

         if (
            parameters["utm_content"] &&
            (
               ['clt_direct', 'clt_priv'].includes(parameters['utm_content'])
            )
         ) {
            // Hide single CTA
            if ($singleCTA) {
               $singleCTA.classList.add('hidden');
            }
            // Show mobile customer CTA (→ messagerie sécurisée)
            if ($mobileCTAStepper) {
               $mobileCTAStepper.classList.remove('hidden');
               document.querySelector('#cta-mobile-stepper ~ p span').classList.remove("hidden");
            }
         }
      }

      // IC2026
      if (discount_code === "IC2026") {
         // Show CTA section
         document.querySelector('.c-section.c-cta').classList.remove('hidden');

         // Hide desktop CTA
         if ($desktopCTAStepper) {
            $desktopCTAStepper.classList.add('hidden');
         }
         // Show single CTA (→ devis générique) for clt_assures and clt_interm
         if ($singleCTA) {
            $singleCTA.classList.remove('hidden');
         }

         if (
            parameters["utm_content"] &&
            (
               ['clt_direct', 'clt_priv'].includes(parameters['utm_content'])
            )
         ) {
            // Hide single CTA
            if ($singleCTA) {
               $singleCTA.classList.add('hidden');
            }
            // Show mobile customer CTA (→ messagerie sécurisée)
            if ($mobileCTAStepper) {
               $mobileCTAStepper.classList.remove('hidden');
               document.querySelector('#cta-mobile-stepper ~ p span').classList.remove("hidden");
            }
         }
      }
   }

    // Specificity for agent => useless for "L'Instant Crédit (IC2024 | ICCR2024)"
    const shouldDisplayAgentSwitch = false; // Not needed for PDC2025 (/!\ tooltip)
    if (shouldDisplayAgentSwitch && parameters["AGA"]) {
       if (discount_code === "PDC2025" || discount_code === "PDCCR2025") {
          document.getElementById("field--cr-owner").classList.remove("hidden");
          document.getElementById("cr-owner").onchange = function(e) {
             discount_code = this.checked ? "PDCCR2025" : "PDC2025";
             computeData(true);
             renderUI();
          }
       }
    }
}

/**
 * initDiscount
 * Initialize discount data (globaldiscount || actioncomdiscount || actioncomdiscount_special)
 */
function initDiscount(discount, creditDuration, creditAmount) {
   if (!discount) {
      return null;
   }

   if (!creditDuration) {
      creditDuration = discount.durations[0];
   }

   if (!creditAmount) {
      creditAmount = parseInt(discount.minimum_amount);
   }

   discount.isAppliable = true;

   discount.isEligible = (discount.durations.length > 0
      && discount.durations.indexOf(creditDuration) !== -1
      && creditAmount >= parseInt(discount.minimum_amount)
      && creditAmount <= parseInt(discount.maximum_amount));

   // https://stackoverflow.com/questions/5324178/javascript-date-parsing-on-iphone
   let discount_start_date_arr = discount.start_date.split(/[- :]/),
       discount_start_date = new Date(
         discount_start_date_arr[0], discount_start_date_arr[1]-1, discount_start_date_arr[2],
         discount_start_date_arr[3], discount_start_date_arr[4], discount_start_date_arr[5]
       ).getTime();
   let discount_end_date_arr = discount.end_date.split(/[- :]/),
       discount_end_date = new Date(
         discount_end_date_arr[0], discount_end_date_arr[1]-1, discount_end_date_arr[2],
         discount_end_date_arr[3], discount_end_date_arr[4], discount_end_date_arr[5]
       ).getTime();
   discount.isValid = (discount.start_date && now >= discount_start_date)
      && (discount.end_date && now <= discount_end_date);

   discount.discountMentions = discount.code ? "" : discount.description;

   // Handle special discount
   // console.log("actioncomdiscounts_special", actioncomdiscounts_special);
   if (actioncomdiscounts_special) {
      let specialDiscountCodes = Object.keys(actioncomdiscounts_special);
      if (discount.code && specialDiscountCodes.indexOf(discount.code) !== -1) {
         let specialDiscount = actioncomdiscounts_special[discount.code];
         // console.log("specialDiscount", specialDiscount);
         discount.isAppliable = (ENV === "APP-MOBILE" && specialDiscount.mobile) ||
            (ENV === "DESKTOP" && specialDiscount.desktop);
         if (discount.isValid && discount.isAppliable) {
            discount.cssTheme = specialDiscount.theme;
            discount.additionalFields = specialDiscount.fields;
            discount.additionalSections = specialDiscount.sections;
            discount.discountLabel = specialDiscount.label;
            discount.discountLabelShort = specialDiscount.labelShort;
            discount.discountIntro = specialDiscount.introduction;
            discount.discountCatchphrase = specialDiscount.catchphrase;
            discount.discountCtaCatchphrase = specialDiscount.cta_catchphrase;
            discount.discountMentions = specialDiscount.mentions;
            discount.discountMentionsShort = specialDiscount.mentionsShort;
            discount.avantagesPP = specialDiscount.avantagesPP;
            discount.hideProposedOffer = specialDiscount.hideProposedOffer === true;
            discount.blocPromoOnTop = specialDiscount.blocPromoOnTop === true;
            discount.hideCurrentOfferInMentions = specialDiscount.hideCurrentOfferInMentions === true;
            renderLegalMentions(specialDiscount.legalMentions);
            if (!parameters["AGA"] && !parameters["A2P"]) {
               setAdditionalFields(specialDiscount.fields);
            }
         }
      }
   }

   return discount;
}

/**
 * setCurrentActionComDiscount
 * Initialize form with actioncom discount (promo)
 * Called only once in presetFormByUrl()
 */
function setCurrentActionComDiscount(code, data, setupForm = true) {
   let projects_list = {};
   let default_project_type = Object.keys(data)[0];

   // Set up current actioncom discount
   discount_code = code;
   // console.log("discount_code", discount_code);
   current_actioncom_discounts = data;
   // console.log("current_actioncom_discounts", current_actioncom_discounts);

   let discount = current_actioncom_discounts[default_project_type] || null;
   // Initialize discount with default value
   if (discount) {
      current_actioncom_discount = initDiscount(discount, discount.durations[0], discount.amount_min);
      // console.log("current_actioncom_discount", current_actioncom_discount);
   }

   // Set up project infos according to current actioncom discount
   if (setupForm && current_actioncom_discount && current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) {
      /* Projects list */
      for (let project in current_actioncom_discounts) {
         if (!projects[project.replace(projectPrefix, "")]) {
            continue;
         }
         projects_list[project] = projects[project.replace(projectPrefix, "")];
      }

      /* Project details */
      if (Object.keys(projects_list).length <= 1) {
         project_type = default_project_type;
         // console.log("project_type", project_type);
         project = project_type ? project_type.replace(projectPrefix, "") : "";
         // console.log("project", project);
         project_name = projects[project].label;
         // console.log("project_name", project_name);
      }

      setCreditData(default_project_type);
   }

   computeData();
   renderUI(projects_list);
}

/**
 * getCurrentActionComDiscount
 * Get current action com discount (with project type)
 */
function getCurrentActionComDiscount(projectType, creditAmount = null, creditDuration = null) {
   if (!current_actioncom_discounts) {
      return;
   }

   let discount = current_actioncom_discounts[projectType] || null;

   if (!discount) {
      return;
   }

   if (creditAmount) {
      creditAmount = discount.amount_min;
   }

   if (!creditDuration) {
      creditDuration = discount.durations[0];
   }

   current_actioncom_discount = initDiscount(discount, creditDuration, creditAmount);
}

/**
 * renderAdditionalFields
 * Display additional fields (in case of special actioncom discount)
 */
function renderAdditionalFields() {
   if (!additional_fields || additional_fields.length <= 0) {
      document.querySelector('.c-additional-fields').classList.add("hidden");
      return;
   }

   if (additional_fields.length === 1 && additional_fields.indexOf('insurance') !== -1) {
      document.querySelector('.c-additional-fields').classList.add("hidden");
   } else {
      document.querySelector('.c-additional-fields').classList.remove("hidden");
   }

   for (let i = 0; i < additional_fields.length; ++i) {
      if (!additional_fields[i]) {
        continue;
      }

      let field = document.getElementById("additional-field--" + additional_fields[i]);
      let className = (field.className).replace("hidden", "").trim();
      field.setAttribute("class", className);
   }
}

/**
 * hideAdditionalFields
 * Hide additional fields (in case of special actioncom discount)
 */
function hideAdditionalFields() {
   if (!additional_fields) {
      return;
   }

   for (let i = 0; i < additional_fields.length; ++i) {
      if (!additional_fields[i]) {
        continue;
      }

      let field = document.getElementById("additional-field--" + additional_fields[i]);
      field.setAttribute("class", (field.className).replace("hidden", "hidden").trim());
   }
}

/**
 * setAdditionalFields
 */
function setAdditionalFields(fields = []) {
   additional_fields = fields;
   // console.log("additional_fields", additional_fields);
}

/**
 * isAdditionalFieldsValid
 */
function isAdditionalFieldsValid(fields = []) {
   if (!fields) {
      return true;
   }

   let isValid = true;

   for (let i = 0; i < fields.length; ++i) {
      if (!fields[i]) {
        continue;
      }

      let field = fields[i],
          value = document.getElementById(field).value;

      if (field == "incomes" || field == "charges") { //|| field == "incomes-nb-months" 
         if (!value) {
            return false;
         }

         isValid = isValid && numerizePrice(value) >= 0;
      }

      if (field == "insurance") {
         continue;
      }
   }

   return isValid;
}

/**
 * isIncomesValid
 */
function isIncomesValid(value) {
   if (!value) {
     return false;
   }

   let numValue = numerizePrice(value);
   return typeof numValue === "number" && !isNaN(numValue);
}

/**
 * isChargesValid
 */
function isChargesValid(value) {
   if (!value) {
     return false;
   }

   let numValue = numerizePrice(value);
   return typeof numValue === "number" && !isNaN(numValue);
}

// AnimateCounter(element, delay, start, className)
// //=include ../../../base/js/components/scrollEvents.js

/**
 * renderAdditionalSections
 * Display additional sections (in case of special actioncom discount)
 */
function renderAdditionalSections() {
   if (!current_actioncom_discount) {
      return;
   }

   if (!current_actioncom_discount.additionalSections) {
      return;
   }

   $(current_actioncom_discount.additionalSections).insertBefore("#legals");
   initAnimations();
}

/**
 * initAnimations
 */
function initAnimations() {
   const count_01 = document.getElementById("count_01");
   const count_02 = document.getElementById("count_02");
   const count_03 = document.getElementById("count_03");
   const count_04 = document.getElementById("count_04");

   if (count_01) {
      new AnimateCounter(count_01, 0, 550, "c-count");
   }
   if (count_02) {
      new AnimateCounter(count_02, 1700, 550, "c-count");
   }
   if (count_03) {
      new AnimateCounter(count_03, 3100, 550, "c-count");
   }
   if (count_04) {
      new AnimateCounter(count_04, 4300, 550, "c-count");
   }
}

/**
 * renderResult
 * Display result
 */
function renderResult() {
  if (
    isProjectValid(project) && isProjectOldnessValid(project_oldness)
    && isCreditAmountValid(credit_amount) && isCreditDurationValid(credit_duration)
  ) {
     $result.classList.remove("hidden");
  } else {
     $result.classList.add("hidden");
  }

   if (!project) {
      return;
   }

   let pTypeTxt = project_name;

   if (projects[project].oldness) {
      pTypeTxt += " ";
      pTypeTxt += project_oldness == "0" ?
        projectOldness["0"][project] : projectOldness[project_oldness];
   }

   let creditDurationInYears = credit_duration / 12;

   $result.querySelector(".project-type").innerHTML = pTypeTxt;

   $resultDetails.querySelector(".credit-amount").innerHTML = stringifyPrice(credit_amount).replace(" ", "&nbsp;");
   
   $resultDetails.querySelectorAll(".credit-duration").forEach(elt => { elt.innerHTML = creditDurationInYears + "&nbsp;" + (creditDurationInYears > 1 ? "ans" : "an"); } );
   
   $resultDetails.querySelectorAll(".insurance-credit-monthly-cost").forEach(elt => { elt.innerHTML = stringifyPrice(insurance_credit_monthly_cost.toFixed(2)).replace(" ", "&nbsp;"); } );
   $resultDetails.querySelector(".deb-rate").innerHTML = (deb_rate.toFixed(2).toString()).replace(".", ",");
   $resultDetails.querySelector(".taeg").innerHTML = (parseFloat(taeg).toFixed(2).toString()).replace(".", ",");
   $resultDetails.querySelector(".setup-fees").innerHTML = stringifyPrice(setup_fees.toFixed(2));
   $resultDetails.querySelector(".credit-total-cost").innerHTML = stringifyPrice((credit_interest + setup_fees).toFixed(2)).replace(" ", "&nbsp;");
   $resultDetails.querySelector(".insurance-total-cost").innerHTML = stringifyPrice((insurance_monthly_cost * credit_duration).toFixed(2)).replace(" ", "&nbsp;");
   $resultDetails.querySelector(".total").innerHTML = stringifyPrice((credit_monthly_cost.toFixed(2) * credit_duration).toFixed(2)).replace(" ", "&nbsp;");
   $resultDetails.querySelector(".total-with-insurance").innerHTML = stringifyPrice((insurance_credit_monthly_cost.toFixed(2) * credit_duration).toFixed(2)).replace(" ", "&nbsp;");
  
   $resultDetails.querySelectorAll(".credit-monthly-cost").forEach(elt => { elt.innerHTML = stringifyPrice(credit_monthly_cost.toFixed(2)).replace(" ", "&nbsp;"); } );

   // insurance
   let $insuranceMonthlyCost = $resultInsurance.getElementsByClassName("insurance-monthly-cost");
   let $taea = $resultInsurance.getElementsByClassName("taea");
   let $insuranceCreditTotalCost = $resultInsurance.getElementsByClassName("insurance-credit-total-cost");

   for (let i = 0; i < $insuranceMonthlyCost.length; ++i) {
     $insuranceMonthlyCost[i].innerHTML = stringifyPrice(insurance_monthly_cost.toFixed(2)).replace(" ", "&nbsp;");
     $taea[i].innerHTML = ((Math.round((taea*10000))/100).toFixed(2).toString()).replace(".", ",");
     $insuranceCreditTotalCost[i].innerHTML = stringifyPrice(insurance_interest.toFixed(2)).replace(" ", "&nbsp;");
   }
}

/**
 * computeData
 * Compute and give value to credit data
 */
function computeData(updateRates = false) {
   if (!credit) {
      return;
   }

   if (!credit_amount || !isCreditAmountValid(credit_amount)) { // || !credit_duration
      return;
   }

   if (updateRates) {
      getRates(credit.identifier, credit_amount, credit_durations, discount_code);
   }
   // console.log('rates', rates);

   // console.log('credit_duration', credit_duration);

   taeg = getTaeg(credit_duration);
   deb_rate = (Math.pow(1 + taeg / 100, 1 / 12) - 1) * 12 * 100;

   credit_monthly_cost = vpm(taeg, credit_duration, credit_amount);
   credit_interest = (credit_monthly_cost.toFixed(2) * credit_duration) - credit_amount;

   insurance_monthly_cost = credit_amount * insurance_rate / 100;
   insurance_credit_monthly_cost = credit_monthly_cost + insurance_monthly_cost;
   insurance_interest = insurance_monthly_cost * credit_duration;

   taea = credit_amount == 0 ? 0 : getTaea(credit_duration, (-insurance_credit_monthly_cost), credit_amount, taeg / 100);
}

/**
 * getTaeg
 * Get TAEG for the given duration
 */
function getTaeg(duration) {
   // console.log('duration', duration);
   if (!rates) {
      return;
   }

   if (!duration) {
      return;
   }

   // console.log(rates);

   return rates[duration].rate;
}

/**
 * getTaea
 * Get TAEA
 * with credit duration (months), insurance monthly cost, credit amount and TAEG
 */
function getTaea(nper, pmt, pv, taeg) {
   let rt = rate(nper, pmt, pv),
      somme = 1 + rt,
      pow = Math.pow(somme, 12),
      pow2 = pow - 1;

   return (pow2 - taeg);
}

/**
 * vpm
 * Calculate the monhly cost
 * with rate, credit duration (months) and credit amount
 */
function vpm(rate, npm, va) {
   let rt = Math.round((Math.pow(1 + rate / 100, 1 / 12) - 1) * 12 * 100 * 100) / 100 / 100 / 12;
   return (va * rt) / (1 - Math.pow((1 + rt), -npm));
}

/**
 * npm
 * Calculate the duration in months
 * with rate, monthly cost and credit amount
 */
function npm(rate, vpm, va) {
   let rt = rate / 100 / 12;
   return Math.log(1 - 1 / (1 - vpm / (va * rt))) / Math.log(1 + rt);
}

/**
 * rate
 * Compute rate
 * with credit duration (months), insurance monthly cost and credit amount
 */
function rate(nper, pmt, pv, fv, type, guess) {
   let rate = (guess || 0.1);
   let y = 0,
      f = 0,
      x0 = 0,
      x1 = 0,
      y0 = 0,
      y1 = 0,
      i = 0;

   if ((Math.abs(rate) > 0.0000001) && (Math.abs(rate) < 20)) {
      y = pv * (1 + nper * rate) + pmt * (1 + rate * (type || 0) * nper + fv);
   } else {
      f = Math.exp(nper * Math.log(1 + rate));
      y = pv * f + pmt * (1 / rate + (type || 0)) * (f - 1) + (fv || 0.0);
   }

   y0 = pv + pmt * nper + (fv || 0.0);
   y1 = pv * f + pmt * (1 / rate + (type || 0)) * (f - 1) + (fv || 0.0);
   i = x0 = 0.0;
   x1 = rate;

   while ((Math.abs(y0 - y1) > 0.0000001) && (i < 100)) {
      rate = (y1 * x0 - y0 * x1) / (y1 - y0);
      x0 = x1;
      x1 = rate;

      if (Math.abs(rate) < 0.0000001) {
         y = pv * (1 + nper * rate) + pmt * (1 + rate * (type || 0) * nper + (fv || 0.0));
      } else {
         f = Math.exp(nper * Math.log(1 + rate));
         y = pv * f + pmt * (1 / rate + (type || 0)) * (f - 1) + (fv || 0.0);
      }

      y0 = y1;
      y1 = y;
      ++i;
   }

   return rate;
}

/**
 * Utils
 */

var $simuPP = document.getElementById("simu-pp"),
    $durationTooltip = document.getElementById("duration-tooltip"),
    $ctaCatchphrase = document.getElementById("cta-catchphrase"),
    $discountLabel = document.getElementById("discount-label"),
    $simuIntro = document.getElementById("simu-intro"),
    $discountCatchphrase = document.getElementById("discount-catchphrase"),
    $discountDescription = document.getElementById("discount-description"),
    $discountMentionsGlobal = document.getElementById("discount-mentions-global"),
    $discountMentions = document.getElementById("discount-mentions");
var $projectField = document.getElementById("field--project"),
    $projectOldnessField = document.getElementById("field--project-oldness"),
    $creditAmountField = document.getElementById("field--credit-amount"),
    $creditTypeField = document.getElementById("field--credit-type"),
    $creditInfos = document.getElementById("infos--credit"),
    $creditDurationField = document.getElementById("field--credit-duration");
var $project = document.getElementById("project"),
    $projectOldness = document.getElementById("project-oldness"),
    $creditAmount = document.getElementById("credit-amount"),
    $creditDuration = document.getElementById("credit-duration"),
    $result = document.getElementById("result"),
    $resultDetails = $result.querySelector(".c-details"),
    $resultSummary = $result.querySelector(".c-summary"),
    $resultInsurance = $result.querySelector(".c-insurance");
var $desktopCTAStepper = document.getElementById("cta-desktop-stepper"),
    $desktopCTA = document.getElementById("cta-desktop"),
    $desktopProspectCTA = document.getElementById("desktop-prospect-cta"),
    $desktopCustomerCTA = document.getElementById("desktop-customer-cta"),
    $mobileCTAStepper = document.getElementById("cta-mobile-stepper"),
    $customerMobileCTA = document.getElementById("mobile-customer-cta"),
    $singleCTA = document.getElementById("single-cta"),
    $axapassionCTA_devis = document.getElementById("axapassion-cta_devis"),
    $axapassionCTA_rdv = document.getElementById("axapassion-cta_rdv"),
    $resetButton = document.getElementById("reset-button");
// Additional fields
var $incomes = document.getElementById("incomes"),
    $charges = document.getElementById("charges"),
    $insurance = document.getElementById("insurance");

/**
 * renderUI
 */
function renderUI(projectsList = {}) {
   renderProject(projectsList);
   renderCreditAmount();
   renderCreditDuration();
   renderDiscount();
   renderResult();
}

/**
 * stringifyPrice
 * Return a number as a string, with space between hundreds
 */
function stringifyPrice(number, prefix, thousand_separator, decimal_separator) {
  if (!number) {
    return "";
  }

  number = number.toString();

  var thousand_separator = thousand_separator || " ",
      decimal_separator = decimal_separator || ".",
      regex		= new RegExp("[^" + decimal_separator + "\\d]", "g"),
      number_string = number.replace(regex, '').toString(),
      split = number_string.split(decimal_separator),
      rest = split[0].length % 3,
      result = split[0].substr(0, rest),
      thousands = split[0].substr(rest).match(/\d{3}/g);

  if (thousands) {
    let separator = rest ? thousand_separator : "";
    result += separator + thousands.join(thousand_separator);
  }

	result = split[1] != undefined ? result + "," + split[1] : result;
	return prefix == undefined ? result : (result ? prefix + result : "");
}

/**
 * numerizePrice
 * Return a formatted price string as a number
 */
function numerizePrice(val) {
  let v = val.toString().replace(/\s/g, "");
  return parseInt(v);
}

/**
 * GetURLParams
 */
class GetURLParams {
  constructor (urlSearch) {
    this.urlSearch = urlSearch
    this.urlParams = this.parseUrlSearch(this.urlSearch)
  }

  parseUrlSearch (query) {
    if (!query) {
      return {};
    }

    let vars = query.split('&');
    let query_string = {};

    for (var i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      pair[0] = pair[0].replace('?', '');
      // If first entry with this name
      if (typeof query_string[pair[0]] === 'undefined') {
        query_string[pair[0]] = decodeURIComponent(pair[1]);
        // If second entry with this name
      } else if (typeof query_string[pair[0]] === 'string') {
        let arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
        query_string[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        query_string[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }

    return query_string;
  }
}

/**
 * findObjectKey
 */
function findObjectKey(obj, value) {
  let key = null;

  for (let prop in obj) {
  	if (obj.hasOwnProperty(prop)) {
  		if (obj[prop] === value) {
        key = prop;
  		}
  	}
  }

  return key;
}

/**
 * getObjectValues
 */
function getObjectValues(obj) {
  if (!obj) {
    return [];
  }

  let values = [];
  for (let key in obj) {
    values.push(obj[key]);
  }

  return values;
}

(function () {
  // Get data
  getCredits();
  getDiscountsSpecial();

  // Handle project
  $project.onchange = function (e) {
     e.preventDefault();
     e.stopPropagation();
     setProject(this.value);
     getCurrentActionComDiscount(project_type);

     let projectClassName = ($project.className).replace("valid", "").replace("error", "").trim();
     $project.setAttribute("class", projectClassName);
     $project.setAttribute("class", projectClassName + " " + (isProjectValid(project) ? "valid" : "error"));
  };
  $projectOldness.onchange = function (e) {
     e.preventDefault();
     e.stopPropagation();
     setProjectOldness(this.value);
     getCurrentActionComDiscount(project_type);

     let projectOldnessClassName = ($projectOldness.className).replace("valid", "").replace("error", "").trim();
     $projectOldness.setAttribute("class", projectOldnessClassName);
     $projectOldness.setAttribute("class", projectOldnessClassName + " " + (isProjectOldnessValid(project_oldness) ? "valid" : "error"));
  };

  // Handle credit amount
  $creditAmount.onkeyup = function (e) {
     e.preventDefault();
     e.stopPropagation();
     setCreditAmount(this.value);
     getCurrentActionComDiscount(project_type, credit_amount);
  };

  // Handle credit duration
  $creditDuration.onchange = function (e) {
     e.preventDefault();
     e.stopPropagation();
     setCreditDuration(this.value);
     getCurrentActionComDiscount(project_type, credit_amount, credit_duration);
  };

  $incomes.onkeyup = function (e) {
     $incomes.value = stringifyPrice(this.value);

     let incomesClassName = ($incomes.className).replace("valid", "").replace("error", "").trim();
     $incomes.setAttribute("class", incomesClassName);
     $incomes.setAttribute("class", incomesClassName + " " + (isIncomesValid(this.value) ? "valid" : "error"));

   //   renderUI();
  }
  $charges.onkeyup = function (e) {
     $charges.value = stringifyPrice(this.value);

     let chargesClassName = ($charges.className).replace("valid", "").replace("error", "").trim();
     $charges.setAttribute("class", chargesClassName);
     $charges.setAttribute("class", chargesClassName + " " + (isChargesValid(this.value) ? "valid" : "error"));

   //   renderUI();
  }

  $insurance.onchange = function (e) {
   $resultDetails.querySelector("#credit-monthly-cost th").classList.remove("semibold", "axablue");
   $resultDetails.querySelector("#credit-monthly-cost td").classList.remove("semibold", "axablue");
   $resultDetails.querySelector("#total th").classList.remove("semibold", "axablue");
   $resultDetails.querySelector("#total td").classList.remove("semibold", "axablue");

   $resultDetails.querySelector("#insurance-credit-monthly-cost th").classList.remove("semibold", "axablue");
   $resultDetails.querySelector("#insurance-credit-monthly-cost td").classList.remove("semibold", "axablue");
   $resultDetails.querySelector("#total-with-insurance th").classList.remove("semibold", "axablue");
   $resultDetails.querySelector("#total-with-insurance td").classList.remove("semibold", "axablue");

   if (this.checked) {
      $resultDetails.querySelector("#insurance-credit-monthly-cost th").classList.add("semibold", "axablue");
      $resultDetails.querySelector("#insurance-credit-monthly-cost td").classList.add("semibold", "axablue");
      $resultDetails.querySelector("#total-with-insurance th").classList.add("semibold", "axablue");
      $resultDetails.querySelector("#total-with-insurance td").classList.add("semibold", "axablue");
   } else {
      $resultDetails.querySelector("#credit-monthly-cost th").classList.add("semibold", "axablue");
      $resultDetails.querySelector("#credit-monthly-cost td").classList.add("semibold", "axablue");
      $resultDetails.querySelector("#total th").classList.add("semibold", "axablue");
      $resultDetails.querySelector("#total td").classList.add("semibold", "axablue");
   }
  }

  $resetButton.onclick = function (e) {
   resetCreditData();
  }

  // Handle CTA
  let $desktopCTAstepper = document.getElementById("cta-desktop-stepper");
  $desktopCTA.onclick = function (e) {
     e.preventDefault();
     e.stopPropagation();

     $desktopCTAstepper.setAttribute("class", $desktopCTAstepper.className + " step1");
  }
  /* Prospect CTA: redirect to souscription form */
  $desktopProspectCTA.onclick = function (e) {
     e.preventDefault();
     e.stopPropagation();

     window.location.href = prospectURL;
  };
  /* Customer URL: redirect to "devis générique" form */
  let creditFormURL = function (e, redirectURL = null, additionalParameters = null) {
      if(!isAdditionalFieldsValid(additional_fields)) {
         for (let i = 0; i < additional_fields.length; ++i) {
            let input = document.getElementById(additional_fields[i]);
            input.dispatchEvent(new KeyboardEvent('keyup'));
         }
         
         return;
      }
      
     e.preventDefault();
     e.stopPropagation();

     if (!redirectURL) {
        redirectURL = customerURL;
     }

     let discountCode = "";
     if (current_actioncom_discount && current_actioncom_discount.isValid && current_actioncom_discount.isEligible) {
        discountCode = discount_code;
     }

     let vehicleOldness = "";
     if (projects[project].oldness) {
        vehicleOldness += project_oldness == "0" ?
           projectOldness["0"][project] : projectOldness[project_oldness];
        vehicleOldness = vehicleOldness.charAt(0).toUpperCase() + vehicleOldness.slice(1);
     }

     window.location.href = redirectURL
        + "?projet=" + encodeURIComponent(project_name)
        + "&ancienneteVehicule=" + encodeURIComponent(vehicleOldness)
        + "&montantPret=" + encodeURIComponent($result.querySelector(".credit-amount").textContent)
        + "&duree=" + encodeURIComponent($result.querySelector(".credit-duration").textContent)
        + "&mensualite_hors_assurance=" + encodeURIComponent($result.querySelector(".credit-monthly-cost").textContent)
        + "&taeg=" + encodeURIComponent($result.querySelector(".taeg").textContent)
        + "&tea=" + encodeURIComponent($result.querySelector(".taea").textContent)
        + "&taux_debiteur=" + encodeURIComponent($result.querySelector(".deb-rate").textContent)
        + "&montant_du=" + encodeURIComponent($result.querySelector(".total").textContent)
        + "&cout_mensuel_assurance=" + encodeURIComponent($result.querySelector(".insurance-monthly-cost").textContent)
        + "&mensualite_avec_assurance=" + encodeURIComponent($result.querySelector(".insurance-credit-monthly-cost").textContent)
        + "&cout_total_credit_hors_assurance=" + encodeURIComponent($result.querySelector(".credit-total-cost").textContent)
        + "&cout_total_assurance=" + encodeURIComponent($result.querySelector(".insurance-total-cost").textContent)
        + "&frais_dossier=" + encodeURIComponent($result.querySelector(".setup-fees").textContent)
        + "&code_promo=" + encodeURIComponent(discountCode)
        + (additionalParameters && additionalParameters.length > 0 ? additionalParameters : "")
        + (redirectURL === customerURL ? "&#1" : ""); // to force "devis générique" form to step 2
  };
  $desktopCustomerCTA.onclick = creditFormURL;
  /* Single CTA */
  let handleSingleCTA = function (e) {
     let redirectURL = null;
     if (parameters["client"] && parameters["client"] === 'oui') {
        redirectURL = customerURL;
     }
     if (parameters["collab"] && parameters["collab"] === 'oui') {
        redirectURL = collabURL;
     }

     let additionalParameters = "";
     if (parameters["utm_source"] && parameters["utm_source"] === 'gmb') {
        additionalParameters += "&" + window.location.search.slice(1, window.location.search.length);
     }
     if (parameters["collab"] && parameters["collab"] === 'oui') {
        additionalParameters += "&" + "simulateur-pp-collab";
     }

     return creditFormURL(e, redirectURL, additionalParameters);
  }
  if ($singleCTA) {
     $singleCTA.onclick = handleSingleCTA;
  }
   /* AXA Passion CTA : redirect to Devis générique  */
   if ($axapassionCTA_devis) {
      $axapassionCTA_devis.onclick = handleSingleCTA;
   }
   /* AXA Passion CTA : redirect to Prise de RDV form */
   if ($axapassionCTA_rdv) {
      $axapassionCTA_rdv.onclick = function (e) {
         e.preventDefault();
         e.stopPropagation();

         if (parameters['projet'] && parameters['projet'] === 'campingcar') {
            window.location.href = prospectURL + "?message=" + encodeURI("Bonjour,\n\nJe fais suite à l\'offre de financement et assurance pour les vans et camping-cars. Je souhaiterais vous rencontrer afin d\'en savoir plus et de bénéficier de votre accompagnement.\n\nJe vous remercie de bien vouloir me recontacter pour une prise de rendez-vous.");
         } else {
            window.location.href = prospectURL;
         }
      }
   }
  /* Mobile customer CTA: redirect to messagerie "Crédit conso" */
  if ($customerMobileCTA) {
     $customerMobileCTA.onclick = function (e) {
				if (!isAdditionalFieldsValid(additional_fields)) {
					for (let i = 0; i < additional_fields.length; ++i) {
							let input = document.getElementById(additional_fields[i]);
							input.dispatchEvent(new KeyboardEvent('keyup'));
					}
					return;
				}
         
        e.preventDefault();
        e.stopPropagation();

        let url = customerMobileURL
           + "?simulateur=pretperso"
           + "&Simulation=" + encodeURIComponent("Prêt Personnel")
           + "&Projet=" + encodeURIComponent(project_name);

        if (projects[project].oldness) {
           url += "&" + encodeURIComponent("Ancienneté_véhicule") + "=" + encodeURIComponent(project_oldness == "0" ? projectOldness["0"][project] : projectOldness[project_oldness]);
        }

        url += "&" + encodeURIComponent("Montant_prêt") + "=" + encodeURIComponent($result.querySelector(".credit-amount").textContent + " €")
            + "&" + encodeURIComponent("Durée") + "=" + encodeURIComponent($result.querySelector(".credit-duration").textContent)
            + "&" + encodeURIComponent("Mensualité_hors_assurance") + "=" + encodeURIComponent($result.querySelector(".credit-monthly-cost").textContent + " €")
            + "&" + encodeURIComponent("TAEG") + "=" + encodeURIComponent($result.querySelector(".taeg").textContent + " %")
            + "&" + encodeURIComponent("TAEA") + "=" + encodeURIComponent($resultInsurance.querySelector(".taea").textContent + " %")
            + "&" + encodeURIComponent("Taux_débiteur") + "=" + encodeURIComponent($result.querySelector(".deb-rate").textContent + " %")
            + "&" + encodeURIComponent("Montant_dû") + "=" + encodeURIComponent($result.querySelector(".total").textContent + " €")
            + "&" + encodeURIComponent("Coût_mensuel_assurance") + "=" + encodeURIComponent($resultInsurance.querySelector(".insurance-monthly-cost").textContent + " €")
            + "&" + encodeURIComponent("Mensualité_avec_assurance") + "=" + encodeURIComponent($result.querySelector(".insurance-credit-monthly-cost").textContent + " €")
            + "&" + encodeURIComponent("Coût_total_crédit_hors_assurance") + "=" + encodeURIComponent($result.querySelector(".credit-total-cost").textContent + " €")
            + "&" + encodeURIComponent("Coût_total_assurance") + "=" + encodeURIComponent($result.querySelector(".insurance-total-cost").textContent + " €")
            + "&" + encodeURIComponent("Frais_dossier") + "=" + encodeURIComponent($result.querySelector(".setup-fees").textContent + " €")
            + "&" + encodeURIComponent("Assurance_emprunteur") + "=" + encodeURIComponent($insurance.checked ? "Oui" : "Non");

        if (current_actioncom_discount && current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) {
           url += "&" + encodeURIComponent("Code_promo") + "=" + encodeURIComponent(discount_code);

           if (current_actioncom_discount.discountLabel.length > 0) {
              url += "&" + encodeURIComponent("Promo") + "=" + encodeURIComponent(current_actioncom_discount.discountLabel);
           }
           if (current_actioncom_discount.discountLabelShort.length > 0) {
              url += "&" + encodeURIComponent("Libellé_promo") + "=" + encodeURIComponent(current_actioncom_discount.discountLabelShort);
           }
           if (current_actioncom_discount.discountMentionsShort.length > 0) {
              url += "&" + encodeURIComponent("Mentions") + "=" + encodeURIComponent(current_actioncom_discount.discountMentionsShort);
           }
        }

        if ($incomes.value.length > 0) { // && $incomesNbMonths.value.length > 0
           // let incomesYear = stringifyPrice(numerizePrice($incomes.value) * numerizePrice($incomesNbMonths.value)) || "0";
           url += "&" + encodeURIComponent("Revenu_mensuel_net") + "=" + encodeURIComponent($incomes.value + " €");
        }
        if ($charges.value.length > 0) {
           url += "&" + encodeURIComponent("Charges_mensuelles") + "=" + encodeURIComponent($charges.value + " €");
        }

        // id GED for messagerie "crédit conso" > "demande de financement" 
        url += "&idGed=270387";

        window.location.href = url;
     };
  }

})();

(function () {

  /* Accordion FAQ */
  function initFaq(toggle) {
   const button = document.createElement('button');
   button.innerText = '-';
   toggle.append(button);
  }
  function setFaqExpanded(toggle, expanded) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      const button = toggle.querySelector('button');
      if (button) {
         button.innerHTML = expanded ? '<span class="desktop">−</span><span class="mobile"><i class="axa-icons axa-icons-arrow-up"></i></span>' : '<span class="desktop">+</span><span class="mobile"><i class="axa-icons axa-icons-arrow-down"></i></span>';
      }
      var questionBlock = toggle.closest('.faq-item');
      if (questionBlock) {
         questionBlock.classList.toggle('is-collapsed', !expanded);
      }
   }

   const faqToggles = document.querySelectorAll('#faq .faq-item__question');
   for (var i = 0; i < faqToggles.length; i++) {
      (function (toggle) {
         initFaq(toggle);
         setFaqExpanded(toggle, false);
         toggle.addEventListener('click', function () {
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            setFaqExpanded(toggle, !expanded);
         });
      })(faqToggles[i]);
   }

})();

